import { styled } from '../../../../../stitches.config';
import { Icon } from '../../../../text/Icon/Icon';
import { PricingEntry } from './Pricing.types';

const PriceEntryContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
  fontSize: '$2',
});

const PriceEntryLabel = styled('div', {
  width: '15rem',
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
  color: '$slate11',
});

const PriceEntryPrice = styled('div', {
  width: '12rem',
});

const AvailabilityTag = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
  padding: '$2 $3',
  borderRadius: '$medium',
  backgroundColor: '$slate6',
});

interface PriceEntryProps {
  entry: PricingEntry;
  title: string;
  icon: string;
}

export function PriceEntry(props: PriceEntryProps) {
  const { entry, title, icon } = props;

  const { price } = entry;
  const [amount, unit] = entry.amount;
  const availability = entry.availabilityTierDescription;

  return (
    <PriceEntryContainer>
      <PriceEntryLabel>
        <Icon icon={icon} /> <span>{title}</span>
      </PriceEntryLabel>
      <PriceEntryPrice>
        <span>from </span>
        <b>${price}</b>
        <span> for </span>
        <b>
          {amount}
          {unit}
        </b>
      </PriceEntryPrice>
      <AvailabilityTag>
        <Icon icon="schedule" />
        {availability}
      </AvailabilityTag>
    </PriceEntryContainer>
  );
}
